module.exports = __webpack_public_path__ + "static/media/T1_DIFF.0e1c9bf2.png";